module.exports = __webpack_public_path__ + "static/media/jujube.b33c1ed8.png";